module.exports = __webpack_public_path__ + "static/media/xfinity-verticle-short-eng.434f19e2.png";